<div class="row" >
    <div class="col-lg-12">
        <div class="card" >
    
            <div class="d-flex card-header p-3">
                    
                <div class="flex-grow-1">
                    <h4 class="card-title mb-0" i18n="@@">New Note for </h4>
                </div>
                <div class="flex-shrink-0 " >
                
                        <div class="d-flex gap-3 align-items-center">
                            <button type="button" class="btn-close" (click)="close()" 
                                id="close-jobListModal" data-bs-dismiss="modal" aria-label="Close">
                            </button>
                        </div>

                </div>
    
            </div>
            <div class="card-body">
                <div class="row" >
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <label  i18n="@@">Message</label>
                            <textarea style="max-height: 50vh;" class="form-control" type="text"  placeholder="Enter message" i18n-placeholder="@@" [(ngModel)]="lineItem.description" (keypress) = "ContactEdited = true" ></textarea>
                        </div>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px;">
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label  i18n="@@">Amount Total</label>
                            <input  class="form-control"  type="text" mask="separator.2" thousandSeparator=""  placeholder="Enter Prepayment Amount" i18n-placeholder="@@" [(ngModel)]= "lineItem.amount" (keypress) = "updateTax()"/>
                        </div> 
                    </div>
                    <div class="col-lg-2">
                        <div class="mb-3">
                            <label  i18n="@@">Total Tax</label>
                            <div class = "row d-flex justify-content">
                                <input  class="form-control flex-shrink" disabled="true" type="text" placeholder="$0.00" i18n-placeholder="@@" value="{{lineItem.tax | currency}}" />
                            </div> 
                        </div> 
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-3">
                            <label  i18n="@@">Taxable</label>
                            <div class="form-check form-switch">
                                <input  class="form-check-input" type="checkbox" [(ngModel)]="isTaxable" (change) = "updateTax()" />
                            </div> 
                        </div> 
                    </div>
                </div>
                <div class="hstack gap-2 justify-content-end">
                    <button type="button" class="btn btn-ghost-success" style=" background-color: rgba(19, 197, 107, 0.1); " i18n="@@Common_text_Close" (click)="close()"><i class="ri-close-line align-bottom"></i> Close</button>
                    <button type="submit" class="btn btn-primary" i18n="@@" (click)="createItem()">Add Item</button>
                </div>
            </div>
            
        </div>
       
    </div> 
</div>
